<template>
  <div class="detail">
    <div class="loading" v-if="loading === true">
      <ScaleLoader />
    </div>
    <div v-if="loaded === true">
      <div class="links" v-if="artist.detail">
        <span v-if="(artist.detail || {}).facebookUrl">
          <a v-bind:href="artist.detail.facebookUrl" target="_blank">
            <font-awesome-icon
              :icon="['fab', 'facebook']"
              class="cursor-pointer"
            />
          </a>
        </span>
        <span v-if="(artist.detail || {}).instagramUrl">
          <a v-bind:href="artist.detail.instagramUrl" target="_blank">
            <font-awesome-icon
              :icon="['fab', 'instagram']"
              class="cursor-pointer" /></a
        ></span>
        <span v-if="(artist.detail || {}).twitterUrl"
          ><a v-bind:href="artist.detail.twitterUrl" target="_blank"
            ><svg
              xmlns="http://www.w3.org/2000/svg"
              height="16"
              width="16"
              viewBox="0 0 512 512"
            >
              <path
                d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8L200.7 275.5 26.8 48H172.4L272.9 180.9 389.2 48zM364.4 421.8h39.1L151.1 88h-42L364.4 421.8z"
              />
            </svg> </a
        ></span>
        <span v-if="(artist.detail || {}).youtubeUrl"
          ><a v-bind:href="artist.detail.youtubeUrl" target="_blank"
            ><font-awesome-icon
              :icon="['fab', 'youtube']"
              class="cursor-pointer" /></a
        ></span>
        <span v-if="(artist.detail || {}).spotifyUrl"
          ><a v-bind:href="artist.detail.spotifyUrl" target="_blank"
            ><font-awesome-icon
              :icon="['fab', 'spotify']"
              class="cursor-pointer" /></a
        ></span>
        <span v-if="(artist.detail || {}).artistWebsiteUrl"
          ><a v-bind:href="artist.detail.artistWebsiteUrl" target="_blank"
            ><font-awesome-icon
              :icon="['fas', 'desktop']"
              class="cursor-pointer" /></a
        ></span>
        <span v-if="(artist.detail || {}).soundcloudUrl"
          ><a v-bind:href="artist.detail.soundcloudUrl" target="_blank"
            ><font-awesome-icon
              :icon="['fab', 'tiktok']"
              class="cursor-pointer" /></a
        ></span>
      </div>
      <div class="description">
        {{ (artist.detail || {}).description }}
      </div>
    </div>
  </div>
</template>

<script>
import { ScaleLoader } from "@saeris/vue-spinners";

export default {
  name: "artistDetail",
  components: {
    ScaleLoader,
  },
  props: {
    artist: Object,
    initLoad: Boolean,
    appId: String,
  },
  data: function () {
    return {
      loading: false,
      loaded: false,
    };
  },
  watch: {
    initLoad: {
      handler: function (initLoadRequest) {
        if (initLoadRequest && !this.artist.detail) {
          this.loadDetail();
        }
        if (this.artist.detail) {
          this.loaded = true;
        }
      },
      immediate: true,
    },
  },
  async mounted() {},
  methods: {
    loadDetail: async function () {
      this.loading = true;
      await this.artist.getDetail();
      this.loading = false;
      this.loaded = true;
      this.$ga.event({
        eventCategory: "artist",
        eventAction: "detail",
        eventLabel: this.artist.title,
      });
    },
  },
};
</script>
